import m from 'mithril'

export default {
  view: vnode => {
    const notebook = require('./notebook.png')

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-13-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">Ønskede Thuleboerne selv at flytte? </h3>

          <p className="log-book-text">Det er der forskellige meninger om.  </p>
          <p className="log-book-text">Departementschef i Grønlandsministeriet, Eske Brun, i avisen Politiken d. 12.5.1953:   </p>

          <p className="log-book-text">“..efter grønlændernes egen opfattelse bliver deres erhverv og deres personlige forhold ikke forringet ved flytningen. Dyrene er allerede ved at drage bort, og så må de følge efter .. ”</p>

          <p className="log-book-text">Fra telegram fra Ritzaus Bureau 11.5.1953:  </p>

          <p className="log-book-text">ESKIMOERNE FLYTTER FRA THULE.</p>
          <p className="log-book-text">..der er allerede opnået enighed, om at eskimoernes ønske om at flytte fra Thule skal opfyldes.. </p>

          <p className="log-book-text">Thuleboer om flytningen: </p>

          <p className="log-book-text">“Så blev vi indkaldt til et møde. Der fik vi at vide, at dem, der ikke flyttede, ville ikke få noget erstatningshus. Vi blev faktisk tvunget til at flytte hertil. Vi skulle flytte på hundeslæder, og vi skulle flytte i en fart. Sådan blev det sagt til os inughuit, og vi havde intet at svare. Gamle Odaq var den eneste, der mente, at vi kunne protestere. Men vi andre vidste slet ikke hvordan. I stedet begyndte folk lige efter mødet at forberede rejsen. </p>
                  
          <figure className="log-book-figure">
            <img src={notebook} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Repræsentanter for den danske stat besøger Thuleboere  før flytningen.
            </figcaption>
          </figure>
        </div>
      </div>
    )
  }
}
